export default "__VITE_ASSET__jaFMinh___"